import { http } from './request'
import type {
  LoginForm,
  RegisterForm,
  User,
  ApiResponse,
  PaginatedResponse,
} from '../types'

export const authApi = {
  // Login
  login(data: LoginForm) {
    return http.post<{ access_token: string; refresh_token: string; token_type: string }>(
      '/v1/auth/login',
      data
    )
  },

  // Register
  register(data: RegisterForm) {
    return http.post<{ user_id: string; message: string }>('/v1/auth/register', data)
  },

  // Refresh token
  refresh() {
    return http.post<{ access_token: string }>('/v1/auth/refresh')
  },

  // Logout
  logout() {
    return http.post('/v1/auth/logout')
  },

  // Get current user
  getCurrentUser() {
    return http.get<User>('/v1/auth/me')
  },

  // Get API token
  getApiToken() {
    return http.get<{ api_token: string }>('/v1/auth/api-token')
  },

  // Regenerate API token
  regenerateApiToken() {
    return http.post<{ api_token: string }>('/v1/auth/api-token')
  },
}

// Admin user APIs
export const getUsers = (
  params?: { page?: number; page_size?: number; search?: string }
): Promise<ApiResponse<PaginatedResponse<User>>> => {
  return http.get('/v1/admin/users', { params })
}

// 获取用户详情（管理端）
export const getUser = (id: string): Promise<ApiResponse<User>> => {
  return http.get(`/v1/admin/users/${id}`)
}

// 更新用户（管理端：状态/余额等）
export const updateUser = (
  id: string,
  data: Partial<Pick<User, 'status' | 'balance' | 'is_admin' | 'phone'>>
): Promise<ApiResponse<User>> => {
  return http.put(`/v1/admin/users/${id}`, data)
}
